import {
    Database,
    FileCsv,
    Factory,
    Gauge,
    Scroll,
    TreeStructure,
} from "@phosphor-icons/react";
import { appPaths } from "../../Routes";
import SideNavigationMenu from "./SideNavigationMenu";

const SideNavigation = () => {
    const sideNavigationItems = [
        {
            icon: Gauge,
            label: "Home",
            path: appPaths.home,
        },
        {
            icon: Factory,
            label: "Emissions Sources",
            path: appPaths.emissionsSources(true),
        },
        {
            icon: Database,
            label: "Data sources",
            path: appPaths.dataSources,
        },
        {
            icon: TreeStructure,
            label: "Activity data",
            path: appPaths.activityData,
        },
        {
            icon: Scroll,
            label: "Evidence",
            path: appPaths.evidence,
        },
        {
            icon: FileCsv,
            label: "Reports",
            path: appPaths.reports,
        },
    ];

    return (
        <nav className="fixed bottom-0 w-full border-t sm:border-t-0 sm:bottom-auto h-[4.653rem] sm:top-14 sm:w-[4.563rem] sm:h-screen py-[0.625rem] px-[0.625rem] border-r border-surface-light-5 bg-surface-light z-40">
            <SideNavigationMenu items={sideNavigationItems} />
        </nav>
    );
};

export default SideNavigation;
